import type { EdgeView, Graph } from '@antv/x6';
import { buildNeonBallLabelAt, REDE_EDGE_FLOW_DURATION_MS } from './x6DiagramSetup';

export interface DiagramEdgeFlowData {
  monitorStatus?: 'online' | 'offline' | 'unknown' | 'neutral';
}

function refreshEdgeLabelPosition(graph: Graph, edge: ReturnType<Graph['getEdges']>[number]): void {
  const view = graph.findViewByCell(edge) as EdgeView | null;
  view?.updateLabelPositions();
}

export function startRedeEdgeFlowLoop(
  getGraph: () => Graph | null,
  shouldPause: () => boolean
): () => void {
  let rafId = 0;
  let startAt: number | null = null;

  const tick = (timestamp: number) => {
    rafId = window.requestAnimationFrame(tick);

    if (shouldPause()) {
      startAt = null;
      return;
    }

    const graph = getGraph();
    if (!graph) return;

    if (startAt == null) startAt = timestamp;
    const progress = ((timestamp - startAt) % REDE_EDGE_FLOW_DURATION_MS) / REDE_EDGE_FLOW_DURATION_MS;

    graph.getEdges().forEach((edge) => {
      const data = edge.getData<DiagramEdgeFlowData>();
      if (data?.monitorStatus !== 'online') return;
      if (edge.getLabels().length === 0) return;

      // silent: true evita re-render completo; updateLabelPositions aplica o deslocamento na view.
      edge.setLabelAt(0, buildNeonBallLabelAt(progress), { silent: true });
      refreshEdgeLabelPosition(graph, edge);
    });
  };

  rafId = window.requestAnimationFrame(tick);

  return () => {
    window.cancelAnimationFrame(rafId);
  };
}
